import { CanActivateFn } from "@angular/router";
import { RouterService } from "../_services/router.service";
import { inject } from "@angular/core";

export const UnauthGuard: CanActivateFn = () => {
    const token: string | null = localStorage.getItem("token");

    if (!token || token.length === 0) {
        return true;
    }

    const router: RouterService = inject(RouterService);
    router.navigate("/status");

    return false;
};
